import React, { useEffect, useState } from 'react';
import { useInfiniteQuery } from 'react-query';
import { Link } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import {
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import { ReactComponent as Inspection } from '../../../assets/img/inspection.svg';
import SuraCard from '../../../components/SuraCard';
import { FLEET_SELF_INSPECTIONS } from '../../../constants/selfInspections.constant';
import { useSelfInspectionDataContext } from '../../../context/SelfInspection/selfInspection.provider';
import {
  CANCEL_SELF_INSPECTIONS,
  useSidebarContext,
} from '../../../context/sidebar/sidebar.provider';
import {
  SELF_INSPECTIONS_QUERY,
  SELF_INSPECTIONS_QUERY_CONFIG,
  selfInspectionsQuery,
} from '../../../query/selfInspections/selfInspections';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background:
        'linear-gradient(79.82deg, #0033A0 0%, rgba(0, 51, 160, 0.7) 100%)',
    },
    container: {
      position: 'relative',
      maxWidth: '100%',
      margin: 'auto',
    },
    buttonNext: {
      background: 'transparent',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      position: 'absolute',
      top: '50%',
      right: '-22px',
      transform: 'translateY(-50%)',
      padding: '2px',
    },
  })
);

const SelfInspectionCard = ({ inspection }: any) => {
  const { vehicle } = inspection;

  return (
    <Box mx={1} mb={3}>
      <ButtonBase
        component={Link}
        to={`/selfInspection/${inspection.id}`}
        style={{ width: '100%' }}
      >
        <SuraCard>
          <Box
            m={1}
            display="flex"
            justifyContent="space-around"
            alignItems="center"
            width="100%"
          >
            <Box mb={2}>
              <Box mb={1}>
                <Typography variant="caption" color="secondary">
                  {' '}
                  Autoinspección necesaria{' '}
                </Typography>
              </Box>
              <Box mb={1}>
                <Typography variant="h3"> Completa los pasos. </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1" color="primary">
                  {' '}
                  {vehicle.license_plate || ''}{' '}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="space-around"
              alignItems="center"
            >
              <Box>{/* <Inspection /> */}</Box>
            </Box>
          </Box>
        </SuraCard>
      </ButtonBase>
    </Box>
  );
};

const SelfInspectionCards = () => {
  const classes = useStyles();
  const { reset, previousInspections } = useSelfInspectionDataContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const { recentCancel, setRecentCancel } = useSidebarContext();
  const [showInspections, setShowInspections] = useState([]);

  const { data: selfInspections } = useInfiniteQuery(
    SELF_INSPECTIONS_QUERY,
    selfInspectionsQuery,
    SELF_INSPECTIONS_QUERY_CONFIG
  );

  useEffect(() => {
    if (selfInspections?.pages && previousInspections.length > 0) {
      const aux = selfInspections.pages?.flat().filter((inspection, index) => {
        // FIXME: use index to map all element in previousInspections array
        return inspection.id !== previousInspections[0].id;
      });
      setShowInspections(aux);
    } else {
      setShowInspections(selfInspections?.pages?.flat());
    }
  }, [previousInspections, selfInspections]);

  useEffect(() => {
    if (recentCancel === CANCEL_SELF_INSPECTIONS) {
      reset();
      setRecentCancel('');
    }
  }, [reset, setRecentCancel, recentCancel]);

  return selfInspections &&
    selfInspections?.pages?.flat().length >= FLEET_SELF_INSPECTIONS ? (
    <Grid container>
      <Grid item xs={12} md={6}>
        <Box mx={1} mb={3}>
          <ButtonBase
            component={Link}
            to="/selfInspection"
            style={{ width: '100%' }}
          >
            <SuraCard>
              <Box
                m={1}
                display="flex"
                justifyContent="space-around"
                alignItems="center"
                width="100%"
              >
                <Box mb={2}>
                  <Box mb={1}>
                    <Typography variant="subtitle2" color="secondary">
                      Autoinspección necesaria para uno o más vehículos
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle1">
                      Completa los pasos.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-around"
                  alignItems="center"
                >
                  <Box>{/* <Inspection /> */}</Box>
                </Box>
              </Box>
            </SuraCard>
          </ButtonBase>
        </Box>
      </Grid>
    </Grid>
  ) : showInspections?.length > 2 ? (
    <CarouselProvider
      naturalSlideWidth={80}
      naturalSlideHeight={500}
      totalSlides={showInspections.length}
      isIntrinsicHeight
      visibleSlides={matches ? 1 : 2}
      infinite
      isPlaying
      interval={5000}
    >
      <div className={classes.container}>
        <Slider>
          {showInspections?.map((inspection: any, index: number) => {
            return (
              <Slide key={index} index={index}>
                <SelfInspectionCard
                  inspection={inspection}
                ></SelfInspectionCard>
              </Slide>
            );
          })}
        </Slider>
        <ButtonNext className={classes.buttonNext}>
          <RightIcon />
        </ButtonNext>
      </div>
    </CarouselProvider>
  ) : (
    <Grid container>
      {showInspections?.map((inspection: any, index: number) => (
        <Grid key={index} xs={12} md={6} item>
          <SelfInspectionCard inspection={inspection}></SelfInspectionCard>
        </Grid>
      )) || null}
    </Grid>
  );
};

export default SelfInspectionCards;
